import Repository from "./RepositoryFactoryMain";
const ADD_TAGS = "add";
const EDIT_TAGS = "update";
const GET_TAGS = "get";
const GET_ALLTAGS = "getAll";

export default {
  addTags(payload) {
    return Repository.post(transformRoute(ADD_TAGS), payload);
  },
  editTags(payload) {
    return Repository.post(transformRoute(EDIT_TAGS), payload);
  },
  getTags() {
    return Repository.get(transformRoute(GET_TAGS));
  },
  getAllTags(payload) {
    return Repository.post(transformRoute(GET_ALLTAGS), payload);
  },
};

const transformRoute = (route) => {
  return `/ecom/tag/${route}`;
};
